import {Trace} from "@commons/types";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";

export type StatoRichiesta = 'IN_ATTESA' | 'IN_VALUTAZIONE' | 'ACCETTATA' | 'RIFIUTATA';

export interface Workflow {
    idWF: number,
    idAziendaMaster: number,
    idDip: number,
    stato: StatoRichiesta | null,
    annullata: boolean,
    noteAnnullata: string,
    livelli: Livello[],
    insertTrace: Trace | undefined,
    deleteTrace: Trace | undefined,
}

export class Workflow {
    static getInstance = (): Workflow => {
        return {
            idWF: 0,
            idAziendaMaster: 0,
            idDip: 0,
            stato: null,
            annullata: false,
            noteAnnullata: '',
            livelli: [Livello.getInstance()],
            insertTrace: undefined,
            deleteTrace: undefined,
        }
    }

    static getDescrizioneStato = (stato: StatoRichiesta | null) => {
        if (stato) {
            switch (stato) {
                case 'IN_ATTESA':
                    return 'in attesa';
                case 'IN_VALUTAZIONE':
                    return 'in valutazione';
                case 'ACCETTATA':
                    return 'accettata';
                case 'RIFIUTATA':
                    return 'respinta';
                default:
                    return '???';
            }
        } else return '???';
    }

    static isDeleted = function (wf: Workflow) {
        return wf.annullata === true;
    };
}

export interface Livello {
    idWF: number,
    idAziendaMaster: number,
    livello: number,
    stato: StatoRichiesta | null,
    richiedente: Soggetto,
    approvatore: Soggetto,
}

export class Livello {
    static getInstance = (): Livello => {
        return {
            idWF: 0,
            idAziendaMaster: 0,
            livello: 0,
            stato: 'IN_ATTESA',
            richiedente: Soggetto.getInstance(),
            approvatore: Soggetto.getInstance(),
        }
    }
}

export interface Soggetto {
    idUser: number
    userName: string
    note: string
    timeStamp: string
}

export class Soggetto {
    static getInstance = (): Soggetto => {
        return {
            idUser: 0,
            userName: '',
            note: '',
            timeStamp: ''
        }
    }

    static factory: ObjectFactory<Soggetto> = (json?) => {
        return merge<Soggetto, Partial<Soggetto> | undefined>(Soggetto.getInstance(), json);
    }
}


